export default __webpack_public_path__ + "static/bg-k-platform-sharing--mobile-a5a0b4a0cf775ad8679bb30427498132.webp";